(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('kendo.data-query.cmn.chunk.js')) :
  typeof define === 'function' && define.amd ? define(['exports', 'kendo.data-query.cmn.chunk'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.kendo = global.kendo || {}, global.kendo._globals = global.kendo._globals || {}, global.kendo._globals.PivotgridCommonCmnChunk = {}), global.kendo._globals.DataQueryCmnChunk));
})(this, (function (exports, kendo_dataQuery_cmn_chunk_js) {
  const __meta__ = {
      id: "pivotgrid-common.cmn.chunk",
      name: "PivotgridCommonCmnChunk",
      category: "web",
      description: "A reusable outputed chunk of code",
      depends: ['data-query.cmn.chunk'],
      hidden: true,
      chunk: true,
      
  };



  var filterFunctionFormats = {
      contains: ", InStr({0}.CurrentMember.MEMBER_CAPTION,\"{1}\") > 0",
      doesnotcontain: ", InStr({0}.CurrentMember.MEMBER_CAPTION,\"{1}\")",
      endswith: ", Right({0}.CurrentMember.MEMBER_CAPTION,Len(\"{1}\"))=\"{1}\"",
      eq: ", {0}.CurrentMember.MEMBER_CAPTION = \"{1}\"",
      neq: ", {0}.CurrentMember.MEMBER_CAPTION = \"{1}\"",
      startswith: ", Left({0}.CurrentMember.MEMBER_CAPTION,Len(\"{1}\"))=\"{1}\""
  };
  var operators = {
      doesnotcontain: 'doesnotcontain',
      in: 'in',
      neq: "neq"
  };
  /**
   * @hidden
   */
  function serializeFilters(filters, cube) {
      var command = "";
      var current = "";
      for (var idx = filters.length - 1; idx >= 0; idx--) {
          current = "SELECT (";
          current += serializeExpression(filters[idx]);
          current += ") ON 0";
          if (idx === filters.length - 1) {
              current += " FROM [" + cube + "]";
              command = current;
          }
          else {
              command = current + " FROM ( " + command + " )";
          }
      }
      return command;
  }
  function serializeExpression(expression) {
      var command = '';
      var value = String(expression.value);
      var field = expression.field;
      var operator = expression.operator;
      if (operator === operators.in) {
          command += "{";
          command += value;
          command += "}";
      }
      else {
          command += operator === operators.neq || operator === operators.doesnotcontain ? '-' : '';
          command += "Filter(";
          command += field + ".MEMBERS";
          command += formatString(filterFunctionFormats[operator], field, value);
          command += ")";
      }
      return command;
  }
  function formatString(str) {
      var values = [];
      for (var _i = 1; _i < arguments.length; _i++) {
          values[_i - 1] = arguments[_i];
      }
      values.forEach(function (value, index) {
          str = str.replace(new RegExp("\\{".concat(index, "\\}"), 'g'), value);
      });
      return str;
  }

  /**
   * @hidden
   */
  function serializeMembers(members, measures, sort) {
      var command = "";
      members = members || [];
      var parsed = parseDescriptors(members);
      var expanded = parsed.expanded;
      var rootNames = getRootNames(parsed.root);
      var crossJoinCommands = [];
      var length = expanded.length;
      var idx = 0;
      var memberName;
      var names = [];
      if (rootNames.length > 1 || measures.length > 0) {
          crossJoinCommands.push(crossJoinCommand(rootNames, measures));
          for (; idx < length; idx++) {
              memberName = expandMemberDescriptor(expanded[idx].name, sort);
              names = mapNames(memberName, rootNames);
              crossJoinCommands.push(crossJoinCommand(names, measures));
          }
          command += crossJoinCommands.join(",");
      }
      else {
          for (; idx < length; idx++) {
              memberName = expandMemberDescriptor(expanded[idx].name, sort);
              names.push(memberName[0]);
          }
          command += rootNames.concat(names).join(",");
      }
      return command;
  }
  /**
   * @hidden
   */
  function measureNames(measures) {
      var length = measures.length;
      var result = [];
      var measure;
      for (var idx = 0; idx < length; idx++) {
          measure = measures[idx];
          result.push(measure.name !== undefined ? measure.name : measure);
      }
      return result;
  }
  function getRootNames(members) {
      var root = [];
      members.forEach(function (member) {
          var name = member.name[0];
          var hierarchyName = baseHierarchyPath(name);
          if (!root.some(function (n) { return n.indexOf(hierarchyName) === 0; })) {
              root.push(name);
          }
      });
      return root;
  }
  function parseDescriptors(members) {
      var expanded = [];
      var child = [];
      var root = [];
      var idx = 0;
      var found;
      for (; idx < members.length; idx++) {
          var member = members[idx];
          var name_1 = member.name;
          found = false;
          if (name_1.length > 1) {
              child.push(member);
          }
          else {
              var hierarchyName = baseHierarchyPath(name_1[0]);
              for (var j = 0, l = root.length; j < l; j++) {
                  if (root[j].name[0].indexOf(hierarchyName) === 0) {
                      found = true;
                      break;
                  }
              }
              if (!found) {
                  root.push(member);
              }
              if (member.expand) {
                  expanded.push(member);
              }
          }
      }
      expanded = expanded.concat(child);
      return {
          expanded: expanded,
          root: root
      };
  }
  function mapNames(names, rootNames) {
      var rootLength = rootNames.length;
      rootNames = rootNames.slice(0);
      for (var idx = 0; idx < names.length; idx++) {
          var name_2 = names[idx];
          for (var j = 0; j < rootLength; j++) {
              var rootName = baseHierarchyPath(rootNames[j]);
              if (name_2.indexOf(rootName) !== -1) {
                  rootNames[j] = name_2;
                  break;
              }
          }
      }
      return rootNames;
  }
  function crossJoinCommand(members, measures) {
      var tmp = members.slice(0);
      if (measures.length > 0) {
          tmp.push("{" + measureNames(measures).join(",") + "}");
      }
      return crossJoin(tmp);
  }
  function expandMemberDescriptor(names, sort) {
      var idx = names.length - 1;
      var name = names[idx];
      var sortDescriptor = sortDescriptorForMember(sort, name);
      if (sortDescriptor && sortDescriptor.dir) {
          name = "ORDER(" + name + ".Children," + sortDescriptor.field + ".CurrentMember.MEMBER_CAPTION," + sortDescriptor.dir + ")";
      }
      else {
          name += ".Children";
      }
      names[idx] = name;
      return names;
  }
  function sortDescriptorForMember(sort, member) {
      for (var idx = 0, length_1 = sort.length; idx < length_1; idx++) {
          if (member.indexOf(sort[idx].field) === 0) {
              return sort[idx];
          }
      }
      return null;
  }
  function baseHierarchyPath(memberName) {
      var parts = memberName.split(".");
      if (parts.length > 2) {
          return parts[0] + "." + parts[1];
      }
      return memberName;
  }
  function crossJoin(names) {
      var result = "CROSSJOIN({";
      var name;
      if (names.length > 2) {
          name = names.pop();
          result += crossJoin(names);
      }
      else {
          result += names.shift();
          name = names.pop();
      }
      result += "},{";
      result += name;
      result += "})";
      return result;
  }

  /**
   * @hidden
   */
  function createRequestBody(options) {
      var command = '<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/"><Header/><Body><Execute xmlns="urn:schemas-microsoft-com:xml-analysis"><Command><Statement>';
      var _a = options.columnAxes, columnAxes = _a === void 0 ? [] : _a, _b = options.rowAxes, rowAxes = _b === void 0 ? [] : _b;
      var _c = options.measureAxes, measureAxes = _c === void 0 ? [] : _c, _d = options.sort, sort = _d === void 0 ? [] : _d, _e = options.filter, filter = _e === void 0 ? [] : _e;
      var measuresRowAxis = options.measuresAxis === "rows";
      command += "SELECT NON EMPTY {";
      if (!columnAxes.length && rowAxes.length && (!measureAxes.length || (measureAxes.length && measuresRowAxis))) {
          columnAxes = rowAxes;
          rowAxes = [];
          measuresRowAxis = false;
      }
      if (!columnAxes.length && !rowAxes.length) {
          measuresRowAxis = false;
      }
      if (columnAxes.length) {
          command += serializeMembers(columnAxes, !measuresRowAxis ? measureAxes : [], sort);
      }
      else if (measureAxes.length && !measuresRowAxis) {
          command += measureNames(measureAxes).join(",");
      }
      command += "} DIMENSION PROPERTIES CHILDREN_CARDINALITY, PARENT_UNIQUE_NAME ON COLUMNS";
      if (rowAxes.length || (measuresRowAxis && measureAxes.length > 1)) {
          command += ", NON EMPTY {";
          if (rowAxes.length) {
              command += serializeMembers(rowAxes, measuresRowAxis ? measureAxes : [], sort);
          }
          else {
              command += measureNames(measureAxes).join(",");
          }
          command += "} DIMENSION PROPERTIES CHILDREN_CARDINALITY, PARENT_UNIQUE_NAME ON ROWS";
      }
      if (filter.length) {
          command += " FROM ";
          command += "(";
          command += serializeFilters(filter, options.connection.cube);
          command += ")";
      }
      else {
          command += " FROM [" + options.connection.cube + "]";
      }
      command += '</Statement></Command><Properties><PropertyList><Catalog>' + options.connection.catalog + '</Catalog><Format>Multidimensional</Format></PropertyList></Properties></Execute></Body></Envelope>';
      return command.replace(/&/g, "&amp;");
  }

  /******************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  /* global Reflect, Promise, SuppressedError, Symbol, Iterator */

  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
  };

  function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  }

  var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
  };

  function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
  }

  function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
  }

  function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
  }

  function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
  };

  function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
  };

  function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
  };

  function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
  };

  function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
  }

  function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  }

  function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
  }

  var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
  }) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });

  function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
  }

  function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }

  function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
  }

  /** @deprecated */
  function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
  }

  /** @deprecated */
  function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
  }

  function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  }

  function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
  }

  function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
  }

  function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
  }

  function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
  }

  function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
  };

  var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  }) : function(o, v) {
    o["default"] = v;
  };

  var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };

  function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  }

  function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
  }

  function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
  }

  function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
  }

  function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
  }

  function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
      if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
      var dispose, inner;
      if (async) {
        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
        dispose = value[Symbol.asyncDispose];
      }
      if (dispose === void 0) {
        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
        dispose = value[Symbol.dispose];
        if (async) inner = dispose;
      }
      if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
      if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
      env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
      env.stack.push({ async: true });
    }
    return value;
  }

  var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
  };

  function __disposeResources(env) {
    function fail(e) {
      env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
      env.hasError = true;
    }
    var r, s = 0;
    function next() {
      while (r = env.stack.pop()) {
        try {
          if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
          if (r.dispose) {
            var result = r.dispose.call(r.value);
            if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
          }
          else s |= 1;
        }
        catch (e) {
          fail(e);
        }
      }
      if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
      if (env.hasError) throw env.error;
    }
    return next();
  }

  function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) {
        return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
            return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
        });
    }
    return path;
  }

  var tslib_es6 = {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __esDecorate,
    __runInitializers,
    __propKey,
    __setFunctionName,
    __metadata,
    __awaiter,
    __generator,
    __createBinding,
    __exportStar,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn,
    __addDisposableResource,
    __disposeResources,
    __rewriteRelativeImportExtension,
  };

  /**
   * @hidden
   */
  function parseResponse(response) {
      var xmlDoc = new DOMParser().parseFromString(response, "text/xml");
      var axes = Array.from(xmlDoc.querySelectorAll("Axis"));
      var cells = Array.from(xmlDoc.querySelectorAll("CellData > Cell"))
          .map(function (cell) { return ({
          fmtValue: getPropertyValue(cell, "FmtValue"),
          ordinal: parseInt(cell.getAttribute("CellOrdinal"), 10),
          value: getPropertyValue(cell, "Value")
      }); });
      var columns = { tuples: [] };
      var rows = { tuples: [] };
      var data = [];
      axes.forEach(function (axis) {
          if (axis.getAttribute('name') !== "SlicerAxis") {
              var tuples = columns.tuples.length === 0 ? columns.tuples : rows.tuples;
              Array.prototype.push.apply(tuples, translateAxis(axis));
          }
      });
      var indexedData = new Array(rows.tuples.length * columns.tuples.length).fill(null);
      cells.forEach(function (c) { indexedData[c.ordinal] = c; });
      var counter = 0;
      rows.tuples.forEach(function (rowTuple) {
          columns.tuples.forEach(function (colTuple) {
              data.push({
                  columnTuple: colTuple,
                  data: indexedData[counter],
                  rowTuple: rowTuple
              });
              counter++;
          });
      });
      return { columns: columns, data: data, rows: rows };
  }
  /**
   * @hidden
   */
  function getPropertyValue(member, name) {
      var node = member.querySelector(name);
      return node ? node.textContent : "";
  }
  function translateAxis(axis) {
      var tuples = Array.from(axis.querySelectorAll("Tuple"));
      return tuples.map(function (tuple) {
          var memberElements = Array.from(tuple.querySelectorAll("Member"));
          var members = memberElements.map(function (member) {
              var lNum = parseInt(getPropertyValue(member, "LNum") || "0", 10);
              var hasChildren = parseInt(getPropertyValue(member, "CHILDREN_CARDINALITY") || "0", 10) > 0;
              return {
                  caption: getPropertyValue(member, "Caption"),
                  children: [],
                  hasChildren: hasChildren,
                  hierarchy: member.getAttribute('Hierarchy'),
                  levelName: getPropertyValue(member, "LName"),
                  levelNum: lNum,
                  name: getPropertyValue(member, "UName"),
                  parentName: getPropertyValue(member, "PARENT_UNIQUE_NAME")
              };
          });
          return { members: members };
      });
  }

  /**
   * @hidden
   */
  var discoverCommands = {
      schemaCatalogs: "DBSCHEMA_CATALOGS",
      schemaCubes: "MDSCHEMA_CUBES",
      schemaDimensions: "MDSCHEMA_DIMENSIONS",
      schemaHierarchies: "MDSCHEMA_HIERARCHIES",
      schemaKPIs: "MDSCHEMA_KPIS",
      schemaLevels: "MDSCHEMA_LEVELS",
      schemaMeasures: "MDSCHEMA_MEASURES",
      schemaMembers: "MDSCHEMA_MEMBERS"
  };
  /**
   * @hidden
   */
  function createDiscoverBody(options) {
      var properties = {};
      var command = '<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/"><Header/><Body><Discover xmlns="urn:schemas-microsoft-com:xml-analysis">';
      command += "<RequestType>" + (discoverCommands[options.command] || options.command) + "</RequestType>";
      command += "<Restrictions>" + serializeOptions("RestrictionList", options.restrictions, true) + "</Restrictions>";
      if (options.connection && options.connection.catalog) {
          properties.Catalog = options.connection.catalog;
      }
      command += "<Properties>" + serializeOptions("PropertyList", properties, false) + "</Properties>";
      command += '</Discover></Body></Envelope>';
      return command;
  }
  function serializeOptions(parentTagName, options, capitalize) {
      var result = "";
      if (options) {
          result += "<" + parentTagName + ">";
          var value = void 0;
          for (var key in options) {
              if (options[key]) {
                  value = options[key];
                  if (capitalize) {
                      key = key.replace(/([A-Z]+(?=$|[A-Z][a-z])|[A-Z]?[a-z]+)/g, "$1_").toUpperCase().replace(/_$/, "");
                  }
                  result += "<" + key + ">" + value + "</" + key + ">";
              }
          }
          result += "</" + parentTagName + ">";
      }
      else {
          result += "<" + parentTagName + "/>";
      }
      return result;
  }

  /**
   * @hidden
   */
  function parseCubes(response) {
      var xmlDoc = new DOMParser().parseFromString(response, "text/xml");
      var rows = Array.from(xmlDoc.querySelectorAll("DiscoverResponse > return > root > row"))
          .map(function (row) { return ({
          name: getPropertyValue(row, "CUBE_NAME"),
          caption: getPropertyValue(row, "CUBE_CAPTION"),
          description: getPropertyValue(row, "DESCRIPTION"),
          type: getPropertyValue(row, "CUBE_TYPE")
      }); });
      return rows;
  }
  /**
   * @hidden
   */
  function parseCatalogs(response) {
      var xmlDoc = new DOMParser().parseFromString(response, "text/xml");
      var rows = Array.from(xmlDoc.querySelectorAll("DiscoverResponse > return > root > row"))
          .map(function (row) { return ({
          name: getPropertyValue(row, "CATALOG_NAME"),
          description: getPropertyValue(row, "DESCRIPTION")
      }); });
      return rows;
  }
  /**
   * @hidden
   */
  function parseMeasures(response) {
      var xmlDoc = new DOMParser().parseFromString(response, "text/xml");
      var rows = Array.from(xmlDoc.querySelectorAll("DiscoverResponse > return > root > row"))
          .map(function (row) { return ({
          name: getPropertyValue(row, "MEASURE_NAME"),
          caption: getPropertyValue(row, "MEASURE_CAPTION"),
          uniqueName: getPropertyValue(row, "MEASURE_UNIQUE_NAME"),
          description: getPropertyValue(row, "DESCRIPTION"),
          aggregator: getPropertyValue(row, "MEASURE_AGGREGATOR"),
          groupName: getPropertyValue(row, "MEASUREGROUP_NAME"),
          displayFolder: getPropertyValue(row, "MEASURE_DISPLAY_FOLDER"),
          defaultFormat: getPropertyValue(row, "DEFAULT_FORMAT_STRING")
      }); });
      return rows;
  }
  /**
   * @hidden
   */
  function parseKPIs(response) {
      var xmlDoc = new DOMParser().parseFromString(response, "text/xml");
      var rows = Array.from(xmlDoc.querySelectorAll("DiscoverResponse > return > root > row"))
          .map(function (row) { return ({
          name: getPropertyValue(row, "KPI_NAME"),
          uniqueName: getPropertyValue(row, "KPI_NAME"),
          caption: getPropertyValue(row, "KPI_CAPTION"),
          value: getPropertyValue(row, "KPI_VALUE"),
          goal: getPropertyValue(row, "KPI_GOAL"),
          status: getPropertyValue(row, "KPI_STATUS"),
          trend: getPropertyValue(row, "KPI_TREND"),
          statusGraphic: getPropertyValue(row, "KPI_STATUS_GRAPHIC"),
          trendGraphic: getPropertyValue(row, "KPI_TREND_GRAPHIC"),
          description: getPropertyValue(row, "KPI_DESCRIPTION"),
          groupName: getPropertyValue(row, "MEASUREGROUP_NAME"),
          type: "kpi"
      }); });
      return rows;
  }
  /**
   * @hidden
   */
  function parseDimensions(response) {
      var xmlDoc = new DOMParser().parseFromString(response, "text/xml");
      var rows = Array.from(xmlDoc.querySelectorAll("DiscoverResponse > return > root > row"))
          .map(function (row) { return ({
          caption: getPropertyValue(row, "DIMENSION_CAPTION"),
          defaultHierarchy: getPropertyValue(row, "DEFAULT_HIERARCHY"),
          description: getPropertyValue(row, "DESCRIPTION"),
          name: getPropertyValue(row, "DIMENSION_NAME"),
          type: parseInt(getPropertyValue(row, "DIMENSION_TYPE"), 10),
          uniqueName: getPropertyValue(row, "DIMENSION_UNIQUE_NAME")
      }); });
      return rows;
  }
  /**
   * @hidden
   */
  function parseHierarchies(response) {
      var xmlDoc = new DOMParser().parseFromString(response, "text/xml");
      var rows = Array.from(xmlDoc.querySelectorAll("DiscoverResponse > return > root > row"))
          .map(function (row) { return ({
          name: getPropertyValue(row, "HIERARCHY_NAME"),
          caption: getPropertyValue(row, "HIERARCHY_CAPTION"),
          description: getPropertyValue(row, "DESCRIPTION"),
          uniqueName: getPropertyValue(row, "HIERARCHY_UNIQUE_NAME"),
          dimensionUniqueName: getPropertyValue(row, "DIMENSION_UNIQUE_NAME"),
          displayFolder: getPropertyValue(row, "HIERARCHY_DISPLAY_FOLDER"),
          origin: getPropertyValue(row, "HIERARCHY_ORIGIN"),
          defaultMember: getPropertyValue(row, "DEFAULT_MEMBER")
      }); });
      return rows;
  }
  /**
   * @hidden
   */
  function parseLevels(response) {
      var xmlDoc = new DOMParser().parseFromString(response, "text/xml");
      var rows = Array.from(xmlDoc.querySelectorAll("DiscoverResponse > return > root > row"))
          .map(function (row) { return ({
          name: getPropertyValue(row, "LEVEL_NAME"),
          caption: getPropertyValue(row, "LEVEL_CAPTION"),
          description: getPropertyValue(row, "DESCRIPTION"),
          uniqueName: getPropertyValue(row, "LEVEL_UNIQUE_NAME"),
          dimensionUniqueName: getPropertyValue(row, "DIMENSION_UNIQUE_NAME"),
          displayFolder: getPropertyValue(row, "LEVEL_DISPLAY_FOLDER"),
          orderingProperty: getPropertyValue(row, "LEVEL_ORDERING_PROPERTY"),
          origin: getPropertyValue(row, "LEVEL_ORIGIN"),
          hierarchyUniqueName: getPropertyValue(row, "HIERARCHY_UNIQUE_NAME")
      }); });
      return rows;
  }
  /**
   * @hidden
   */
  function parseMembers(response) {
      var xmlDoc = new DOMParser().parseFromString(response, "text/xml");
      var rows = Array.from(xmlDoc.querySelectorAll("DiscoverResponse > return > root > row"))
          .map(function (row) { return ({
          name: getPropertyValue(row, "MEMBER_NAME"),
          caption: getPropertyValue(row, "MEMBER_CAPTION"),
          uniqueName: getPropertyValue(row, "MEMBER_UNIQUE_NAME"),
          dimensionUniqueName: getPropertyValue(row, "DIMENSION_UNIQUE_NAME"),
          hierarchyUniqueName: getPropertyValue(row, "HIERARCHY_UNIQUE_NAME"),
          levelUniqueName: getPropertyValue(row, "LEVEL_UNIQUE_NAME"),
          childrenCardinality: getPropertyValue(row, "CHILDREN_CARDINALITY")
      }); });
      return rows;
  }

  var discoverParser = {
      schemaCatalogs: parseCatalogs,
      schemaCubes: parseCubes,
      schemaDimensions: parseDimensions,
      schemaHierarchies: parseHierarchies,
      schemaKPIs: parseKPIs,
      schemaLevels: parseLevels,
      schemaMeasures: parseMeasures,
      schemaMembers: parseMembers
  };
  /**
   * Fetches the data.
   *
   * @param options RequestOptions
   * @returns Promise<ResponseData>
   *
   * @example
   * const options: RequestOptions = { ... };
   *
   * fetchData(options).then(createDataState).then((dataState: DataState) => {
   *  // Update the UI
   * });
   */
  /**
   * @hidden
   */
  var fetchData = function (fetchOptions, options) { return __awaiter(void 0, void 0, void 0, function () {
      var init, response, stringResponse;
      return __generator(this, function (_a) {
          switch (_a.label) {
              case 0:
                  init = __assign({ body: createRequestBody(options), headers: { 'Content-Type': 'text/xml' }, method: 'POST' }, fetchOptions.init);
                  return [4 /*yield*/, fetch(fetchOptions.url, init)];
              case 1:
                  response = _a.sent();
                  return [4 /*yield*/, response.text()];
              case 2:
                  stringResponse = _a.sent();
                  return [2 /*return*/, parseResponse(stringResponse)];
          }
      });
  }); };
  /**
   * @hidden
   */
  var fetchDiscover = function (fetchOptions, options) { return __awaiter(void 0, void 0, void 0, function () {
      var init, response, stringResponse;
      return __generator(this, function (_a) {
          switch (_a.label) {
              case 0:
                  init = __assign({ body: createDiscoverBody(options), headers: { 'Content-Type': 'text/xml' }, method: 'POST' }, fetchOptions.init);
                  return [4 /*yield*/, fetch(fetchOptions.url, init)];
              case 1:
                  response = _a.sent();
                  return [4 /*yield*/, response.text()];
              case 2:
                  stringResponse = _a.sent();
                  return [2 /*return*/, discoverParser[options.command](stringResponse)];
          }
      });
  }); };

  var isMeasure = function (member) { return member.hierarchy === '[Measures]'; };
  // A typical tree depth count won't work for the Pivot,
  // as each branch can have lower number of nodes than the total number of levels
  /**
   * @hidden
   */
  var getMaxNesting = function (node, set) {
      if (set === void 0) { set = new Set(); }
      (node.children || []).forEach(function (child) {
          set.add(child.levelName);
          getMaxNesting(child, set);
      });
      return set.size;
  };
  /**
   * @hidden
   */
  var getMaxExpansion = function (node) {
      var expanded = 0;
      (node.children || []).forEach(function (child) {
          expanded += (getMaxExpansion(child) || 1);
      });
      return expanded;
  };
  /**
   * @hidden
   */
  var generateNormalizedPath = function (node, parent) {
      return (parent && (parent.hierarchy === node.hierarchy)
          ? __spreadArray(__spreadArray([], (parent.normalizedPath || []).slice(0, -1), true), [node.name || null], false) : __spreadArray(__spreadArray([], ((parent && parent.normalizedPath) ? parent.normalizedPath : []), true), [node.name], false)).filter(Boolean);
  };
  /**
   * @hidden
   */
  var generatePath = function (node, parent) {
      return (parent && (parent.hierarchy === node.hierarchy)
          ? __spreadArray(__spreadArray([], (parent.path || []).slice(0, -1), true), [((node.levelNum === 0 ? node.hierarchy : node.name) || null)], false) : __spreadArray(__spreadArray([], ((parent && parent.path) ? parent.path : []), true), [node.levelNum === 0 ? node.hierarchy : node.name], false)).filter(Boolean);
  };
  /**
   * @hidden
   */
  var toMatrix = function (node, rowIndex, colIndex, maxDepth, maxBreadth, matrix, leafs, parent) {
      if (rowIndex === void 0) { rowIndex = -1; }
      if (colIndex === void 0) { colIndex = 0; }
      if (maxDepth === void 0) { maxDepth = undefined; }
      if (maxBreadth === void 0) { maxBreadth = undefined; }
      if (matrix === void 0) { matrix = undefined; }
      if (leafs === void 0) { leafs = undefined; }
      if (parent === void 0) { parent = undefined; }
      var branchDepth = getMaxNesting(node);
      var branchBreadth = getMaxExpansion(node);
      var depth = maxDepth || branchDepth;
      var breadth = maxBreadth || branchBreadth;
      var matrixResult = matrix ? matrix.slice() : [];
      var leafsResult = leafs ? leafs.slice() : new Array(breadth);
      var index = matrixResult.findIndex(function (l) { return l && l.name === node.levelName && l.level === node.levelNum; });
      var level = matrixResult[index];
      var row = {
          name: node.levelName,
          level: node.levelNum,
          index: rowIndex,
          cells: new Array(breadth).fill(null)
      };
      var inject = rowIndex !== -1 && colIndex !== -1;
      var cell = {
          caption: node.caption,
          name: node.name,
          levelName: node.levelName,
          levelNum: node.levelNum,
          hasChildren: node.hasChildren,
          parentName: node.parentName,
          hierarchy: node.hierarchy,
          total: (node.total !== undefined ? node.total : false) || (parent && parent.children.length <= 1 && parent.total),
          parent: parent,
          rowIndex: rowIndex,
          colIndex: colIndex,
          depth: 1,
          breadth: 1,
          path: node.path || [],
          normalizedPath: node.normalizedPath || [],
          children: node.children.filter(function (c) { return c.hierarchy === node.hierarchy; })
      };
      if (inject) {
          if (level) {
              level.cells[colIndex] = cell;
              if (level.index >= rowIndex) {
                  rowIndex = level.index;
              }
          }
          else {
              if (matrixResult[rowIndex] && matrixResult[rowIndex].cells.length) {
                  for (var idx = rowIndex; idx < matrixResult.length; idx++) {
                      var shiftedRow = matrixResult[idx];
                      shiftedRow.index++;
                  }
                  matrixResult.splice(rowIndex, 0, row);
                  matrixResult[rowIndex].cells[colIndex] = cell;
              }
              else {
                  matrixResult[rowIndex] = row;
                  matrixResult[rowIndex].cells[colIndex] = cell;
              }
          }
      }
      var collOffset = 0;
      if (node.children && node.children.length) {
          node.children.forEach(function (child) {
              var _a = toMatrix(child, rowIndex + 1, colIndex + collOffset, depth, breadth, matrixResult, leafsResult, cell), newMatrix = _a[0], newLeafs = _a[1], childBreadth = _a[3];
              collOffset += (childBreadth || 1);
              matrixResult = newMatrix.slice();
              leafsResult = newLeafs.slice();
          });
      }
      else if (node.normalizedPath) {
          leafsResult[colIndex] = { total: cell.total, path: node.normalizedPath };
      }
      cell.depth = branchDepth;
      cell.breadth = branchBreadth;
      return [
          matrixResult,
          leafsResult,
          branchDepth,
          branchBreadth
      ];
  };
  var withTotal = function (root, parent, index) {
      if (parent === void 0) { parent = null; }
      if (index === void 0) { index = 0; }
      var hierarchy;
      var alt = __assign(__assign({}, root), { total: true, hasChildren: false, children: [] });
      for (var childIndex = 0; childIndex < root.children.length; childIndex++) {
          var child = withTotal(root.children[childIndex], root, childIndex);
          hierarchy = hierarchy || child.hierarchy;
          if (child.hierarchy !== hierarchy
              && parent
              && !parent.children.some(function (c) { return c.total && c.name === alt.name; })
              && !root.total) {
              alt.children.push(child);
              root.children.splice(childIndex, 1);
              childIndex--;
          }
      }
      if (root.children.filter(function (c) { return !c.total; }).length >= 1
          && parent
          && !parent.children.some(function (c) { return c.total && c.name === alt.name; })
          && !root.total) {
          var childHierarchy = root.children[0].hierarchy;
          if (root.hierarchy === childHierarchy) {
              parent.children.splice(index + 1, 0, alt);
          }
      }
      return root;
  };
  /**
   * @hidden
   */
  var toTree = function (tuples) {
      var root = { children: [] };
      var map = {};
      if (tuples.every(function (t) { return t.members.length === 1 && isMeasure(t.members[0]); })) {
          // toTree(columnsTuples) - The case where there are only measure(s) and no columns.
          return {
              children: tuples.map(function (t) {
                  var member = t.members[0];
                  return __assign(__assign({}, member), { normalizedPath: [member.name], parentName: member.name, path: [member.hierarchy] });
              })
          };
      }
      for (var tupleIndex = 0; tupleIndex < tuples.length; tupleIndex++) {
          var tuple = copy(tuples[tupleIndex]);
          var key = "";
          var _loop_1 = function (memberIndex) {
              var member = tuple.members[memberIndex];
              var parent_1;
              if (root.children && root.children.length === 0) {
                  parent_1 = root;
              }
              else if (map[key] && !map[key + member.name] && member.levelNum === 0) {
                  parent_1 = map[key];
              }
              else if (map[key + member.parentName] && member.levelNum > 0 && !map[key + member.parentName + member.name]) {
                  parent_1 = map[key + member.parentName];
              }
              else if (!map[key + member.parentName] && member.levelNum > 0 && !map[key + member.parentName + member.name]) {
                  var parentKey = Object.keys(map).find(function (e) { return member.parentName === map[e].name; });
                  if (parentKey) {
                      parent_1 = map[parentKey];
                  }
              }
              if (parent_1) {
                  member.path = generatePath(member, parent_1);
                  member.normalizedPath = generateNormalizedPath(member, parent_1);
                  var intruderIndex = parent_1.children.findIndex(function (c) { return c.hierarchy !== parent_1.hierarchy; });
                  if (intruderIndex !== -1) {
                      parent_1.children.splice(intruderIndex, 0, member);
                  }
                  else {
                      parent_1.children.push(member);
                  }
              }
              member.parentName += member.name;
              key += member.parentName;
              if (!map[key]) {
                  map[key] = member;
              }
          };
          for (var memberIndex = 0; memberIndex < tuple.members.length; memberIndex++) {
              _loop_1(memberIndex);
          }
      }
      return copy(withTotal(root));
  };
  /**
   * @hidden
   */
  var toData = function (data, columns, rows, breadth, depth) {
      var result = Array.from(new Array(depth), function () { return ({ cells: Array.from(new Array(breadth), function () { return null; }) }); });
      var hash = function (names) { return names.join('|'); };
      var membersNames = function (tuple) { return tuple.members.map(function (m) { return m.name; }); };
      var columnsIndexes = new Map();
      var rowsIndexes = new Map();
      columns.forEach(function (colMembers, idx) { columnsIndexes.set(hash(colMembers.path), idx); });
      rows.forEach(function (rowMembers, idx) { rowsIndexes.set(hash(rowMembers.path), idx); });
      data.forEach(function (item) {
          var colIndex = columnsIndexes.get(hash(membersNames(item.columnTuple)));
          var rowIndex = rowsIndexes.get(hash(membersNames(item.rowTuple)));
          if (colIndex !== undefined && rowIndex !== undefined) {
              if (!result[rowIndex].cells[colIndex]) {
                  result[rowIndex].row = rows[rowIndex].path;
                  result[rowIndex].cells[colIndex] = item;
              }
          }
      });
      return result;
  };
  var rotateMatrix = function (matrix, leafs, depth, breadth) {
      var result = new Array(breadth);
      for (var colIndex = 0; colIndex < breadth; colIndex++) {
          for (var rowIndex = 0; rowIndex < depth; rowIndex++) {
              if (matrix[rowIndex] && matrix[rowIndex].cells[colIndex]) {
                  var cell = matrix[rowIndex].cells[colIndex];
                  if (!result[colIndex]) {
                      result[colIndex] = {
                          cells: new Array(depth).fill(null)
                      };
                  }
                  result[colIndex].cells[rowIndex] = __assign(__assign({}, cell), { rowSpan: cell.colSpan, colSpan: cell.rowSpan });
              }
          }
      }
      return [result, leafs, breadth, depth];
  };
  /**
   * @hidden
   */
  var toColumns = function (root) {
      var _a = toMatrix(root), matrix = _a[0], leafs = _a[1], depth = _a[2], breadth = _a[3];
      for (var colIndex = 0; colIndex < breadth; colIndex++) {
          var cell = null;
          for (var rowIndex = 0; rowIndex < depth; rowIndex++) {
              if (matrix[rowIndex]) {
                  var next = matrix[rowIndex].cells[colIndex];
                  if (!next && cell) {
                      cell.rowSpan = (cell.rowSpan || 1) + 1;
                  }
                  if (cell) {
                      cell.colSpan = cell.breadth || 1;
                  }
                  if (next) {
                      cell = next;
                  }
              }
          }
      }
      return [matrix, leafs, depth, breadth];
  };
  /**
   * @hidden
   */
  var toRows = function (root) {
      var _a = toMatrix(root), matrix = _a[0], leafs = _a[1], depth = _a[2], breadth = _a[3];
      for (var colIndex = 0; colIndex < breadth; colIndex++) {
          var cell = null;
          for (var rowIndex = 0; rowIndex < depth; rowIndex++) {
              if (matrix[rowIndex]) {
                  var next = matrix[rowIndex].cells[colIndex];
                  if (!next && cell) {
                      cell.rowSpan = (cell.rowSpan || 1) + 1;
                  }
                  if (cell) {
                      cell.colSpan = cell.breadth;
                  }
                  if (next) {
                      cell = next;
                  }
              }
          }
      }
      return rotateMatrix(matrix, leafs, depth, breadth);
  };
  /**
   * @hidden
   */
  var cloneDate = function (date) { return date ? new Date(date.getTime()) : null; };
  /**
   * @hidden
   */
  function clone(obj) {
      var result = {};
      cloneObject(obj, result);
      return result;
  }
  /**
   * @hidden
   */
  function cloneObject(obj, result) {
      for (var field in obj) {
          if (obj.hasOwnProperty(field)) {
              var value = obj[field];
              result[field] = cloneValue(value, result[field]);
          }
      }
  }
  /**
   * @hidden
   */
  function cloneValue(value, nextValue) {
      if (Array.isArray(value)) {
          return cloneArray(value);
      }
      else if (value instanceof Date) {
          return cloneDate(value);
      }
      else if (value && typeof value === 'object') {
          var newNextValue = nextValue || {};
          cloneObject(value, newNextValue);
          return newNextValue;
      }
      else {
          return value;
      }
  }
  /**
   * @hidden
   */
  function copy(obj) {
      return JSON.parse(JSON.stringify(obj));
  }
  /**
   * @hidden
   */
  function cloneArray(array) {
      return array.map(function (value) { return cloneValue(value, undefined); });
  }
  var kpiMeasure = function (name, measure, type) {
      return {
          hierarchyUniqueName: name,
          uniqueName: measure,
          caption: measure,
          measure: measure,
          name: measure,
          type: type,
          kpi: true
      };
  };
  /**
   * @hidden
   */
  function buildKPIMeasures(node) {
      var name = node.name;
      return [
          kpiMeasure(name, node.value, "value"),
          kpiMeasure(name, node.goal, "goal"),
          kpiMeasure(name, node.status, "status"),
          kpiMeasure(name, node.trend, "trend")
      ];
  }
  /**
   * @hidden
   */
  var addKPI = function (data) {
      var found;
      var idx = 0;
      for (; idx < data.length; idx++) {
          if (data[idx].type === 2) {
              found = true;
              break;
          }
      }
      if (found) {
          data.splice(idx + 1, 0, {
              caption: "KPIs",
              defaultHierarchy: "[KPIs]",
              name: "KPIs",
              uniqueName: "[KPIs]"
          });
      }
  };
  /**
   * @hidden
   */
  var compareAxisWithField = function (a, b) { return String(a.name) === String([(b.defaultHierarchy
          ? b.defaultHierarchy
          : b.uniqueName)]); };
  /**
   * @hidden
   */
  var compareAxes = function (a, b) { return String(a.name) === String(b.name); };
  /**
   * @hidden
   */
  var filterField = function (axes, out) {
      var _loop_2 = function (i) {
          var axis = axes[i];
          var index = axis.name.findIndex(function (name) { return compareAxisWithField({ name: [name] }, out) || String(name).startsWith(out.uniqueName); });
          if (index !== -1) {
              if (index === axis.name.length - 1 || axis.name.length === 1) {
                  axes.splice(i, 1);
              }
              else {
                  axis.name.splice(index, 1);
                  var duplicatedAxisIndex = axes.findIndex(function (ax) { return ax !== axis && String(ax.name) === String(axis.name); });
                  if (duplicatedAxisIndex !== -1) {
                      axes[duplicatedAxisIndex] = __assign(__assign(__assign({}, axes[duplicatedAxisIndex]), axis), ((axes[duplicatedAxisIndex].expand || axis.expand) ? { expand: true } : {}));
                      axes.splice(i, 1);
                  }
              }
          }
      };
      for (var i = axes.length - 1; i >= 0; i--) {
          _loop_2(i);
      }
  };
  /**
   * @hidden
   */
  var insertAxis = function (axes, toInsert, state) {
      var index = -1;
      if (state.dropTarget && state.dropDirection) {
          var offset = state.dropDirection
              ? (state.dropDirection === 'before'
                  ? 0
                  : 1)
              : 0;
          index = axes.findIndex(function (c) { return compareAxes(c, state.dropTarget); }) + offset;
      }
      if (index !== -1) {
          axes.forEach(function (axis) {
              var _a;
              if (axis.expand && axis.name.length > 1 && axis.name.length > index) {
                  (_a = axis.name).splice.apply(_a, __spreadArray([index, 0], toInsert.name, false));
              }
          });
          axes.splice(index, 0, toInsert);
      }
      else {
          axes.push(toInsert);
      }
  };
  /**
   * @hidden
   */
  var reverseColumnsByMeasures = function (columns) {
      var firstColumn = columns.length && columns[0];
      var lastMember = firstColumn && firstColumn.members[firstColumn.members.length - 1];
      if (lastMember && isMeasure(lastMember)) {
          var columnsArr = [];
          var measuresCount = new Set(columns.map(function (col) { return col.members[col.members.length - 1].caption; })).size;
          for (var i = 0; i < columns.length; i += measuresCount) {
              columnsArr.push(columns.slice(i, i + measuresCount));
          }
          var result_1 = [];
          columnsArr.forEach(function (arr) {
              result_1.push.apply(result_1, arr.reverse());
          });
          return result_1;
      }
      return columns;
  };

  /**
   * Creates the state object. See `fetchData`.
   *
   * @param response - ResponseData
   * @returns DataState
   */
  /**
   * @hidden
   */
  var createDataState = function (response) {
      var state = {
          columns: reverseColumnsByMeasures(response.columns.tuples),
          data: response.data,
          rows: response.rows.tuples
      };
      return state;
  };

  /**
   * Creates a collection of AxisDescriptor base on the expandTree.
   * @param expandTree - { [key: string]: boolean }
   * @returns AxisDescriptor[]
   *
   * @example
   * See `setRowExpand` or `setColumnExpand` functions.
   */
  /**
   * @hidden
   */
  function createAxisDescriptors(expandTree) {
      var descriptors = [];
      for (var _i = 0, _a = Object.keys(expandTree); _i < _a.length; _i++) {
          var key = _a[_i];
          descriptors.push({ name: JSON.parse(key), expand: expandTree[key] });
      }
      return descriptors;
  }

  /**
   * Sets sort descriptors to request options.
   *
   * @param options - RequestOptions
   * @param sort - SortDescriptor[]
   *
   * @example
   * const options: RequestOptions = { ... };
   * const sort: SortDescriptor[] = [{ ... }, { ... }];
   * setSort(options, sort);
   * // skip the sort parameter to clear current filter - setSort(options);
   *
   * fetchData(options).then(createDataState).then((dataState: DataState) => {
   *  // Update the UI
   * });
   */
  /**
   * @hidden
   */
  var setSort = function (options, sort) {
      if (sort === void 0) { sort = []; }
      options.sort = sort;
  };

  /**
   * Sets filter descriptors to request options.
   *
   * @param options - RequestOptions
   * @param filter - FilterDescriptor[]
   *
   * @example
   * const options: RequestOptions = { ... };
   * const filter: FilterDescriptor[] = [{ ... }, { ... }];
   * setFilter(options, filter);
   * // skip the filter parameter to clear current filter - setFilter(options);
   *
   * fetchData(options).then(createDataState).then((dataState: DataState) => {
   *  // Update the UI
   * });
   */
  /**
   * @hidden
   */
  var setFilter = function (options, filter) {
      if (filter === void 0) { filter = []; }
      options.filter = filter;
  };

  /**
   * @hidden
   */
  var HEADERS_ACTION;
  (function (HEADERS_ACTION) {
      HEADERS_ACTION["toggle"] = "HEADERS_ACTION_TOGGLE";
      HEADERS_ACTION["expand"] = "HEADERS_ACTION_EXPAND";
      HEADERS_ACTION["collapse"] = "HEADERS_ACTION_COLLAPSE";
  })(HEADERS_ACTION || (HEADERS_ACTION = {}));
  var findPath = function (node, matchFn, matched) {
      var result = new Set();
      node.children.forEach(function (child) {
          var match = matchFn(child);
          if (matched) {
              result.add(String(child.path));
          }
          findPath(child, matchFn, (matched || match)).map(function (h) {
              result.add(h);
          });
      });
      return Array.from(result.values());
  };
  /**
   * @hidden
   */
  var headersReducer = function (state, action) {
      switch (action.type) {
          case HEADERS_ACTION.toggle: {
              var existing = state.find((function (s) { return String(s.name) === String(action.payload); }));
              return headersReducer(state, __assign(__assign({}, action), { type: existing && (existing.expand)
                      ? HEADERS_ACTION.collapse
                      : HEADERS_ACTION.expand }));
          }
          case HEADERS_ACTION.expand: {
              var existing_1 = state.find((function (s) { return String(s.name) === String(action.payload); }));
              if (existing_1 && existing_1.expand === true) {
                  return state;
              }
              else if (existing_1 && (existing_1.expand === false || existing_1.expand === undefined)) {
                  return state.map(function (s) { return s === existing_1 ? (__assign(__assign({}, existing_1), { expand: true })) : s; });
              }
              else {
                  var nextState = state.slice();
                  nextState.push({ name: action.payload, expand: true });
                  return nextState;
              }
          }
          case HEADERS_ACTION.collapse: {
              var filtered_1 = findPath(action.tree, function (node) { return !node.total && String(node.path) === String(action.payload); });
              var newState = state.slice()
                  .filter(function (h) { return !filtered_1.some(function (f) { return f === String(h.name); }); })
                  .map(function (h) { return (__assign(__assign({}, h), { expand: Boolean(h.expand) })); })
                  .map(function (h) { return (String(h.name) === String(action.payload))
                  ? action.payload.length > 1 ? undefined : { name: action.payload, expand: false }
                  : h; })
                  .filter(Boolean);
              return newState;
          }
          default: {
              return state;
          }
      }
  };

  /**
   * @hidden
   */
  exports.H = void 0;
  (function (PIVOT_CONFIGURATOR_ACTION) {
      // Selection
      PIVOT_CONFIGURATOR_ACTION["toggleSelection"] = "PIVOT_CONFIGURATOR_ACTION_TOGGLE_SELECTION";
      PIVOT_CONFIGURATOR_ACTION["addColumnAxis"] = "PIVOT_CONFIGURATOR_ACTION_ADD_COLUMN_AXIS";
      PIVOT_CONFIGURATOR_ACTION["addColumnAxes"] = "PIVOT_CONFIGURATOR_ACTION_ADD_COLUMN_AXES";
      PIVOT_CONFIGURATOR_ACTION["removeColumnAxis"] = "PIVOT_CONFIGURATOR_ACTION_REMOVE_COLUMN_AXIS";
      PIVOT_CONFIGURATOR_ACTION["removeColumnAxes"] = "PIVOT_CONFIGURATOR_ACTION_REMOVE_COLUMN_AXES";
      PIVOT_CONFIGURATOR_ACTION["addRowAxis"] = "PIVOT_CONFIGURATOR_ACTION_ADD_ROW_AXIS";
      PIVOT_CONFIGURATOR_ACTION["addRowAxes"] = "PIVOT_CONFIGURATOR_ACTION_ADD_ROW_AXES";
      PIVOT_CONFIGURATOR_ACTION["removeRowAxis"] = "PIVOT_CONFIGURATOR_ACTION_REMOVE_ROW_AXIS";
      PIVOT_CONFIGURATOR_ACTION["removeRowAxes"] = "PIVOT_CONFIGURATOR_ACTION_REMOVE_ROW_AXES";
      PIVOT_CONFIGURATOR_ACTION["addMeasureAxis"] = "PIVOT_CONFIGURATOR_ACTION_ADD_MEASURE_AXIS";
      PIVOT_CONFIGURATOR_ACTION["addMeasureAxes"] = "PIVOT_CONFIGURATOR_ACTION_ADD_MEASURE_AXES";
      PIVOT_CONFIGURATOR_ACTION["removeMeasureAxis"] = "PIVOT_CONFIGURATOR_ACTION_REMOVE_MEASURE_AXIS";
      PIVOT_CONFIGURATOR_ACTION["removeMeasureAxes"] = "PIVOT_CONFIGURATOR_ACTION_REMOVE_MEASURE_AXES";
      // Removal
      PIVOT_CONFIGURATOR_ACTION["remove"] = "PIVOT_CONFIGURATOR_ACTION_REMOVE";
      // Sort
      PIVOT_CONFIGURATOR_ACTION["setSort"] = "PIVOT_CONFIGURATOR_ACTION_SET_SORT";
      // Filter
      PIVOT_CONFIGURATOR_ACTION["setFilter"] = "PIVOT_CONFIGURATOR_ACTION_SET_FILTER";
      PIVOT_CONFIGURATOR_ACTION["addFilter"] = "PIVOT_CONFIGURATOR_ACTION_ADD_FILTER";
      PIVOT_CONFIGURATOR_ACTION["changeFilter"] = "PIVOT_CONFIGURATOR_ACTION_CHANGE_FILTER";
      PIVOT_CONFIGURATOR_ACTION["removeFilter"] = "PIVOT_CONFIGURATOR_ACTION_REMOVE_FILTER";
      // Drag
      PIVOT_CONFIGURATOR_ACTION["setDragItem"] = "PIVOT_CONFIGURATOR_ACTION_SET_DRAGITEM";
      PIVOT_CONFIGURATOR_ACTION["drop"] = "PIVOT_CONFIGURATOR_ACTION_DROP";
      PIVOT_CONFIGURATOR_ACTION["setDropZone"] = "PIVOT_CONFIGURATOR_ACTION_SET_DROP_ZONE";
      PIVOT_CONFIGURATOR_ACTION["setDropTarget"] = "PIVOT_CONFIGURATOR_ACTION_SET_DROP_TARGET";
      PIVOT_CONFIGURATOR_ACTION["setDropDirection"] = "PIVOT_CONFIGURATOR_ACTION_SET_DROP_DIRECTION";
  })(exports.H || (exports.H = {}));
  /**
   * @hidden
   */
  var configuratorReducer = function (state, action) {
      var newRows;
      var newColumns;
      var newMeasures;
      var newSort;
      var newFilter;
      var newDragitem;
      var newDropZone;
      var newDropDirection;
      var newDropTarget;
      switch (action.type) {
          case exports.H.toggleSelection: {
              if (Array.isArray(action.payload)) {
                  // TODO;
              }
              else {
                  var payload_1 = action.payload;
                  if (payload_1.type === 2 || 'aggregator' in payload_1) {
                      if (state.measureAxes.some(function (s) { return compareAxisWithField(s, payload_1); })) {
                          return configuratorReducer(state, __assign(__assign({}, action), { type: exports.H.removeMeasureAxis }));
                      }
                      else {
                          return configuratorReducer(state, __assign(__assign({}, action), { type: exports.H.addMeasureAxis }));
                      }
                  }
                  else if (payload_1.type === 'kpi') {
                      var measures = buildKPIMeasures(payload_1);
                      if (measures.every(function (m) { return state.measureAxes.some(function (s) { return compareAxisWithField(s, m); }); })) {
                          return configuratorReducer(state, __assign(__assign({}, action), { type: exports.H.removeMeasureAxes, payload: measures }));
                      }
                      else {
                          return configuratorReducer(state, __assign(__assign({}, action), { type: exports.H.addMeasureAxes, payload: measures.filter(function (m) { return !state.measureAxes.some(function (s) { return compareAxisWithField(s, m); }); }) }));
                      }
                  }
                  else if (action.payload.kpi) {
                      if (state.measureAxes.some(function (s) { return compareAxisWithField(s, payload_1); })) {
                          return configuratorReducer(state, __assign(__assign({}, action), { type: exports.H.removeMeasureAxis }));
                      }
                      else {
                          return configuratorReducer(state, __assign(__assign({}, action), { type: exports.H.addMeasureAxis }));
                      }
                  }
                  else {
                      if (state.columnAxes.some(function (s) { return compareAxisWithField(s, payload_1); })) {
                          return configuratorReducer(state, __assign(__assign({}, action), { type: exports.H.removeColumnAxis }));
                      }
                      else if (state.rowAxes.some(function (s) { return compareAxisWithField(s, payload_1); })) {
                          return configuratorReducer(state, __assign(__assign({}, action), { type: exports.H.removeRowAxis }));
                      }
                      else if ((state.columnAxes && state.columnAxes.length) && (!state.rowAxes || !state.rowAxes.length)) {
                          return configuratorReducer(state, __assign(__assign({}, action), { type: exports.H.addRowAxis }));
                      }
                      else {
                          return configuratorReducer(state, __assign(__assign({}, action), { type: exports.H.addColumnAxis }));
                      }
                  }
              }
              break;
          }
          case exports.H.addColumnAxis: {
              newColumns = __spreadArray(__spreadArray([], (state.columnAxes || []), true), [
                  { name: [action.payload.defaultHierarchy || action.payload.uniqueName] }
              ], false);
              break;
          }
          case exports.H.addColumnAxes: {
              // TODO;
              break;
          }
          case exports.H.removeColumnAxis: {
              newColumns = __spreadArray([], (state.columnAxes || []).filter(function (s) { return !compareAxisWithField(s, action.payload); }), true);
              filterField(newColumns, action.payload);
              break;
          }
          case exports.H.removeColumnAxes: {
              // TODO;
              break;
          }
          case exports.H.addRowAxis: {
              newRows = __spreadArray(__spreadArray([], (state.rowAxes || []), true), [
                  { name: [action.payload.defaultHierarchy || action.payload.uniqueName] }
              ], false);
              break;
          }
          case exports.H.addRowAxes: {
              // TODO;
              break;
          }
          case exports.H.removeRowAxis: {
              newRows = __spreadArray([], (state.rowAxes || []).filter(function (s) { return !compareAxisWithField(s, action.payload); }), true);
              filterField(newRows, action.payload);
              break;
          }
          case exports.H.removeRowAxes: {
              // TODO;
              break;
          }
          case exports.H.addMeasureAxis: {
              newMeasures = __spreadArray(__spreadArray([], (state.measureAxes || []), true), [
                  { name: [action.payload.defaultHierarchy || action.payload.uniqueName] }
              ], false);
              break;
          }
          case exports.H.removeMeasureAxis: {
              newMeasures = __spreadArray([], (state.measureAxes || []).filter(function (s) { return !compareAxisWithField(s, action.payload); }), true);
              break;
          }
          case exports.H.addMeasureAxes: {
              newMeasures = __spreadArray(__spreadArray([], (state.measureAxes || []), true), (action.payload || []).map(function (p) { return ({ name: [p.defaultHierarchy || p.uniqueName] }); }), true);
              break;
          }
          case exports.H.removeMeasureAxes: {
              newMeasures = __spreadArray([], (state.measureAxes || []).filter(function (s) { return !action.payload.some(function (p) { return compareAxisWithField(s, p); }); }), true);
              break;
          }
          case exports.H.remove: {
              if (state.columnAxes.some(function (s) { return compareAxes(s, action.payload); })) {
                  newColumns = __spreadArray([], state.columnAxes.filter(function (s) { return !compareAxes(s, action.payload); }), true);
                  filterField(newColumns, { uniqueName: action.payload.name });
              }
              if (state.rowAxes.some(function (s) { return compareAxes(s, action.payload); })) {
                  newRows = __spreadArray([], state.rowAxes.filter(function (s) { return !compareAxes(s, action.payload); }), true);
                  filterField(newRows, { uniqueName: action.payload.name });
              }
              if (state.measureAxes.some(function (s) { return compareAxes(s, action.payload); })) {
                  newMeasures = __spreadArray([], state.measureAxes.filter(function (s) { return !compareAxes(s, action.payload); }), true);
              }
              break;
          }
          case exports.H.setDragItem:
              newDragitem = action.payload;
              break;
          case exports.H.setDropZone:
              newDropZone = action.payload;
              break;
          case exports.H.setDropTarget:
              newDropTarget = action.payload;
              break;
          case exports.H.setDropDirection:
              newDropDirection = action.payload;
              break;
          case exports.H.drop:
              if (state.dragItem && state.dropZone) {
                  var currentColumn = state.columnAxes.find(function (s) { return compareAxes(s, action.payload); });
                  var currentRow = state.rowAxes.find(function (s) { return compareAxes(s, action.payload); });
                  var currentMeasure = state.measureAxes.find(function (s) { return compareAxes(s, action.payload); });
                  var current = void 0;
                  if (currentColumn) {
                      current = currentColumn;
                      newColumns = __spreadArray([], state.columnAxes.filter(function (s) { return !compareAxes(s, action.payload); }), true);
                      filterField(newColumns, { uniqueName: action.payload.name });
                  }
                  if (currentRow) {
                      current = currentRow;
                      newRows = __spreadArray([], state.rowAxes.filter(function (s) { return !compareAxes(s, action.payload); }), true);
                      filterField(newRows, { uniqueName: action.payload.name });
                  }
                  if (currentMeasure) {
                      current = currentMeasure;
                      newMeasures = __spreadArray([], state.measureAxes.filter(function (s) { return !compareAxes(s, action.payload); }), true);
                  }
                  switch (state.dropZone) {
                      case 'columnAxes': {
                          newColumns = newColumns || state.columnAxes.slice();
                          insertAxis(newColumns, current, state);
                          break;
                      }
                      case 'rowAxes': {
                          newRows = newRows || state.rowAxes.slice();
                          insertAxis(newRows, current, state);
                          break;
                      }
                      case 'measureAxes': {
                          newMeasures = newMeasures || state.measureAxes.slice();
                          insertAxis(newMeasures, current, state);
                          break;
                      }
                      default:
                          break;
                  }
              }
              newDragitem = null;
              newDropZone = null;
              newDropTarget = null;
              break;
          case exports.H.setSort:
              newSort = action.payload;
              break;
          case exports.H.setFilter:
              if (Array.isArray(action.payload)) {
                  newFilter = action.payload;
              }
              else {
                  newFilter = [action.payload];
              }
              break;
          case exports.H.addFilter:
              newFilter = (state.filter || []).slice();
              if (Array.isArray(action.payload)) {
                  newFilter.push.apply(newFilter, action.payload);
              }
              else {
                  newFilter.push(action.payload);
              }
              break;
          case exports.H.changeFilter:
              newFilter = (Array.isArray(action.payload)
                  ? (state.filter || []).map(function (f) { return action.payload.some(function (a) { return a.field === f.field; })
                      ? action.payload.find(function (a) { return a.field === f.field; })
                      : f; })
                  : (state.filter || []).map(function (f) { return f.field === action.payload.field
                      ? action.payload
                      : f; }));
              break;
          case exports.H.removeFilter:
              newFilter = (state.filter || []).slice();
              if (Array.isArray(action.payload)) {
                  newFilter = newFilter.filter(function (f) { return !action.payload.some(function (p) { return p.field === f.field &&
                      p.operator === f.operator; }); });
              }
              else {
                  newFilter = newFilter.filter(function (f) { return !(f.field === action.payload.field
                      && f.operator === action.payload.operator); });
              }
              break;
          default:
              break;
      }
      return {
          dragItem: newDragitem,
          dropTarget: newDropTarget,
          dropDirection: newDropDirection,
          dropZone: newDropZone,
          columnAxes: newColumns,
          rowAxes: newRows,
          measureAxes: newMeasures,
          filter: newFilter,
          sort: newSort
      };
  };

  // tslint:disable:object-literal-sort-keys
  /**
   * The available built-in types of local-data aggregates.
   */
  var AggregateType;
  (function (AggregateType) {
      AggregateType[AggregateType["Sum"] = 0] = "Sum";
      AggregateType[AggregateType["Count"] = 1] = "Count";
      AggregateType[AggregateType["Min"] = 2] = "Min";
      AggregateType[AggregateType["Max"] = 3] = "Max";
      AggregateType[AggregateType["Average"] = 4] = "Average";
  })(AggregateType || (AggregateType = {}));
  var count = 0;
  /**
   * Creates a new `Aggregate` object of the specified type.
   * This is typically used for generating aggregate objects required for each measure column in the pivot grid.
   *
   * @param type - The type of aggregate to create (e.g., Sum, Count, Min, Max, Average).
   * @returns The generated aggregate object.
   */
  var createAggregate = function (type) {
      var key = "".concat(AggregateType[type], "_").concat(count++);
      switch (type) {
          case AggregateType.Sum:
              return {
                  init: function (data) {
                      if ((key in data) === false) {
                          data[key] = 0;
                      }
                  },
                  merge: function (src, dest) {
                      dest[key] += src[key];
                  },
                  accumulate: function (acc, value) {
                      acc[key] += value;
                  },
                  result: function (data) { return data[key]; },
                  format: function (value) { return value.toFixed(2); }
              };
          case AggregateType.Count:
              return {
                  init: function (data) {
                      if ((key in data) === false) {
                          data[key] = 0;
                      }
                  },
                  merge: function (src, dest) {
                      dest[key] += src[key];
                  },
                  accumulate: function (acc, _value) {
                      acc[key] += 1;
                  },
                  result: function (data) { return data[key]; },
                  format: function (value) { return value.toFixed(); }
              };
          case AggregateType.Min:
              return {
                  init: function (data) {
                      if (key in data === false) {
                          data[key] = Number.POSITIVE_INFINITY;
                      }
                  },
                  merge: function (src, dest) {
                      dest[key] = Math.min(src[key], dest[key]);
                  },
                  accumulate: function (acc, value) {
                      acc[key] = Math.min(value, acc[key]);
                  },
                  result: function (data) { return (Number.isFinite(data[key]) ? data[key] : NaN); },
                  format: function (value) { return value.toFixed(2); }
              };
          case AggregateType.Max:
              return {
                  init: function (data) {
                      if ((key in data) === false) {
                          data[key] = Number.NEGATIVE_INFINITY;
                      }
                  },
                  merge: function (src, dest) {
                      dest[key] = Math.max(src[key], dest[key]);
                  },
                  accumulate: function (acc, value) {
                      acc[key] = Math.max(value, acc[key]);
                  },
                  result: function (data) { return Number.isFinite(data[key]) ? data[key] : NaN; },
                  format: function (value) { return value.toFixed(2); }
              };
          case AggregateType.Average:
              var sumProp_1 = "".concat(key, "_sum");
              var countProp_1 = "".concat(key, "_count");
              return {
                  init: function (data) {
                      if ((countProp_1 in data) === false) {
                          data[sumProp_1] = 0;
                          data[countProp_1] = 0;
                      }
                  },
                  merge: function (src, dest) {
                      dest[sumProp_1] += src[sumProp_1];
                      dest[countProp_1] += src[countProp_1];
                  },
                  accumulate: function (acc, value) {
                      acc[sumProp_1] += value;
                      acc[countProp_1] += 1;
                  },
                  result: function (data) { return data[sumProp_1] / data[countProp_1]; },
                  format: function (value) { return value.toFixed(2); }
              };
          default:
              throw new Error('Invalid aggregate type provided');
      }
  };
  /**
   * Represents the aggregate object which calculates the total value. Applicable for local data binding.
   */
  var sumAggregate = createAggregate(AggregateType.Sum);
  /**
   * Represents the aggregate object which calculates the count value. Applicable for local data binding.
   */
  var countAggregate = createAggregate(AggregateType.Count);
  /**
   * Represents the aggregate object which calculates the minimum value. Applicable for local data binding.
   */
  var minAggregate = createAggregate(AggregateType.Min);
  /**
   * Represents the aggregate object which calculates the maximum value. Applicable for local data binding.
   */
  var maxAggregate = createAggregate(AggregateType.Max);
  /**
   * Represents the aggregate object which calculates the average value. Applicable for local data binding.
   */
  var averageAggregate = createAggregate(AggregateType.Average);

  function forEachDesc(desc, callbackfn) {
      if ('filters' in desc) {
          desc.filters.map(function (child) { return forEachDesc(child, callbackfn); });
      }
      else {
          callbackfn(desc);
      }
  }
  var filterFields = function (filter, callback) {
      var descriptors = Array.isArray(filter) ? filter : filter.filters;
      descriptors.forEach(function (desc) { return forEachDesc(desc, callback); });
  };
  /** @hidden */
  var initializeFiltering = function (rows, columns, filter) {
      var compositeFilter = filter ?
          (Array.isArray(filter) ? { logic: 'and', filters: filter } : filter) : undefined;
      var predicate = compositeFilter ? kendo_dataQuery_cmn_chunk_js.c(compositeFilter) : function () { return true; };
      var axes = rows.concat(columns);
      var fieldValues = [];
      filterFields(filter || [], function (desc) {
          if ('field' in desc && desc.field) {
              fieldValues.push(desc.field);
          }
      });
      var result = { hasFilter: false, predicate: predicate, filteringAxes: [] };
      if (fieldValues.some(function (f) { return typeof f === 'function'; })) {
          result.filteringAxes = axes.slice();
      }
      else if (fieldValues.length > 0) {
          var filteringFields_1 = Array.from(new Set(fieldValues).values());
          var filteringAxes = axes.filter(function (a) { return filteringFields_1.indexOf(a.key) >= 0; });
          result.filteringAxes = filteringAxes;
      }
      result.hasFilter = result.filteringAxes.length > 0;
      return result;
  };

  /** @hidden */
  var subNode = function (node, field, initialNode) {
      var childNode = node.get(field);
      if (!childNode) {
          childNode = initialNode || new Map();
          node.set(field, childNode);
      }
      return childNode;
  };
  var separator = '&';
  /** @hidden */
  var createKey = function (key, value) { return key + separator + value; };
  /** @hidden */
  var splitKeyValue = function (keyValue) {
      var separatorIndex = keyValue.indexOf(separator);
      if (separatorIndex !== -1) {
          var key = keyValue.substring(0, separatorIndex);
          var value = keyValue.substring(separatorIndex + 1);
          return [key, value];
      }
      else {
          return [keyValue, undefined];
      }
  };

  var calculateColumnData = function (node, measures, dataField) {
      node.forEach(function (childNode, k) {
          if (k !== dataField) {
              if (childNode.size > 0) {
                  calculateColumnData(childNode, measures, dataField);
              }
              var childData_1 = childNode.get(dataField);
              var parentData_1 = subNode(node, dataField, {});
              measures.forEach(function (m) {
                  m.aggregate.init(parentData_1);
                  m.aggregate.merge(childData_1, parentData_1);
              });
          }
      });
  };
  /** @hidden */
  var mergeTrees = function (src, dest, measures, dataField) {
      src.forEach(function (srcChild, k) {
          var destChild;
          if (k !== dataField) {
              destChild = subNode(dest, k);
              mergeTrees(srcChild, destChild, measures, dataField);
          }
          else {
              destChild = subNode(dest, k, {});
              measures.forEach(function (m) {
                  m.aggregate.init(destChild);
                  m.aggregate.merge(srcChild, destChild);
              });
          }
      });
  };
  var calculateColumns = function (node, measures, columnsData, dataField) {
      node.forEach(function (childNode, k) {
          if (k !== columnsData) {
              if (childNode.size > 0) {
                  calculateColumns(childNode, measures, columnsData, dataField);
              }
              var srcColumns = subNode(childNode, columnsData);
              var destColumns = subNode(node, columnsData);
              mergeTrees(srcColumns, destColumns, measures, dataField);
          }
      });
  };
  /** @hidden */
  var createDataTree = function (data, rows, columns, measures, fields, filter) {
      var result = new Map();
      var cache = new Map();
      var axes = rows.concat(columns);
      var leafNodes = new Set();
      var dataField = fields.dataField, columnsData = fields.columnsData;
      var _a = initializeFiltering(rows, columns, filter), hasFilter = _a.hasFilter, predicate = _a.predicate, filteringAxes = _a.filteringAxes;
      var empty = '';
      data.forEach(function (dataItem) {
          if (hasFilter) {
              var filteringDataItem_1 = {};
              filteringAxes.forEach(function (axis) { filteringDataItem_1[axis.key] = axis.displayValue(dataItem); });
              if (!predicate(filteringDataItem_1)) {
                  return;
              }
          }
          var values = axes.map(function (a) { return a.displayValue(dataItem); });
          var dataKey = empty.concat.apply(empty, values);
          var nodeData = cache.get(dataKey);
          if (!nodeData) {
              var node_1 = result;
              var eachAxis = function (axis) {
                  node_1 = subNode(node_1, createKey(axis.key, axis.displayValue(dataItem)));
              };
              rows.forEach(eachAxis);
              node_1 = subNode(node_1, columnsData);
              leafNodes.add(node_1);
              columns.forEach(eachAxis);
              nodeData = {};
              node_1.set(dataField, nodeData);
              cache.set(dataKey, nodeData);
              measures.forEach(function (m) {
                  m.aggregate.init(nodeData);
              });
          }
          measures.forEach(function (m) {
              m.aggregate.accumulate(nodeData, m.value(dataItem));
          });
      });
      leafNodes.forEach(function (leaf) { return calculateColumnData(leaf, measures, dataField); });
      calculateColumns(result, measures, columnsData, dataField);
      return result;
  };
  /** @hidden */
  var cloneDataTree = function (dataTree, dataField, measures) {
      var result = new Map();
      mergeTrees(dataTree, result, measures, dataField);
      return result;
  };

  var createPath = function (name, axes, path) {
      var _a = splitKeyValue(name), key = _a[0], value = _a[1];
      var result = path.slice();
      if (key && value) {
          var axis = axes.find(function (a) { return a.key === key; });
          var caption_1 = axis ? axis.caption : '';
          return result.map(function (p) { return p === caption_1 ? name : p; });
      }
      return result;
  };
  var membersNode = function (tree, members, field, axisSettings, measures, dataField, cache) {
      var cacheData = cache || new Map();
      var path = axisSettings.map(function (a) { return a.caption; });
      while (members.length > 1 && axisSettings.some(function (a) { return a.caption === members[members.length - 1].caption; })) {
          members.pop();
          path.pop();
      }
      var node = tree;
      members.forEach(function (m, i) {
          path = createPath(m.name, axisSettings, path);
          if (node && !axisSettings.some(function (a) { return a.caption === m.name; })) {
              if (!node.has(m.name) && !cacheData.has(path.slice(0, path.indexOf(m.name) + 1).join('-'))) {
                  var currentLevel = Array.from(node).find(function (n) { return n[0] !== field; });
                  var currentLevelNode = currentLevel && currentLevel[0];
                  var levelField_1 = currentLevelNode && splitKeyValue(currentLevelNode)[0];
                  var depth = levelField_1 ? i - axisSettings.findIndex(function (a) { return a.key === levelField_1; }) : 0;
                  var _loop_1 = function (t) {
                      var data = [];
                      node.forEach(function (value, key) {
                          if (key !== field) {
                              data.push.apply(data, Array.from(value).filter(function (d) { return d[0] !== field; }));
                          }
                      });
                      var next = new Map();
                      data.forEach(function (item) {
                          if (next.has(item[0])) {
                              var dest = next.get(item[0]);
                              var src = item[1];
                              var newDest = new Map();
                              mergeTrees(dest, newDest, measures, dataField);
                              mergeTrees(src, newDest, measures, dataField);
                              next.set(item[0], newDest);
                          }
                          else {
                              next.set(item[0], new Map(item[1]));
                          }
                      });
                      var currentPath = path.slice(0, path.indexOf(m.name));
                      next.forEach(function (value, key) {
                          cacheData.set(createPath(key, axisSettings, currentPath.concat([key])).join('-'), value);
                      });
                      next.set(field, node.get(field));
                      node = next;
                  };
                  for (var t = 0; t < depth; t++) {
                      _loop_1(t);
                  }
              }
              node = node.get(m.name) || cacheData.get(path.slice(0, path.indexOf(m.name) + 1).join('-'));
          }
      });
      return node;
  };
  /** @hidden */
  var readData = function (dataTree, rowTuples, columnTuples, fields, columnSettings, rowSettings, measures) {
      var data = [];
      var dataField = fields.dataField, columnsData = fields.columnsData;
      var rowsCache = new Map();
      rowTuples.forEach(function (row) {
          var rowNode = membersNode(dataTree, row.members.slice(), columnsData, rowSettings, measures, dataField, rowsCache);
          var rowColumnsNode = rowNode && rowNode.get(columnsData);
          columnTuples.forEach(function (col) {
              var members = col.members.slice();
              var measure = measures[0];
              if (members[members.length - 1].levelName === "[Measures].[MeasuresLevel]") {
                  var measuresMember_1 = members.pop();
                  measure = measures.find(function (m) { return String(m.name) === measuresMember_1.caption; }) || measure;
              }
              var colNode = rowColumnsNode && membersNode(rowColumnsNode, members, dataField, columnSettings, measures, dataField);
              var value = '', fmtValue = '';
              var ordinal = 0;
              if (colNode && measure) {
                  var result = measure.aggregate.result(colNode.get(dataField));
                  value = String(result);
                  fmtValue = measure.aggregate.format(result);
              }
              data.push({
                  columnTuple: col,
                  data: { fmtValue: fmtValue, ordinal: ordinal, value: value },
                  rowTuple: row
              });
          });
      });
      return data;
  };

  var getTopMembersTuple = function (parentFields, axesSettings) {
      var allTuple = { members: [] };
      parentFields.forEach(function (topField) {
          var axis = axesSettings.find(function (a) { return a.key === topField; });
          var caption = axis ? axis.caption : "";
          var member = {
              caption: caption,
              children: [],
              hasChildren: true,
              parentName: "",
              levelNum: 0,
              levelName: caption,
              hierarchy: topField,
              name: caption
          };
          allTuple.members.push(member);
      });
      return allTuple;
  };
  var sortFunc = function (descriptor, axe) {
      return function (a, b) {
          var order = descriptor.dir;
          var sortableA = axe.sortValue(splitKeyValue(a[0])[1]);
          var sortableB = axe.sortValue(splitKeyValue(b[0])[1]);
          if (sortableA < sortableB) {
              return order === "asc" ? -1 : 1;
          }
          if (sortableA > sortableB) {
              return order === "asc" ? 1 : -1;
          }
          return 0;
      };
  };
  var mergeData = function (src, dest, exclude) {
      src.forEach(function (srcChild, k) {
          if (!exclude[k]) {
              var destChild = subNode(dest, k);
              mergeData(srcChild, destChild, exclude);
          }
      });
  };
  var childrenByKeys = function (dataTree, keys, exclude) {
      var result = [];
      var nodeData = function (node) { return Array.from(node).filter(function (n) { return !exclude[n[0]]; }); };
      var element = new Map(dataTree);
      var next;
      var _loop_1 = function (i) {
          next = element.get(keys[i]);
          if (next) {
              element = new Map(next);
          }
          else if (i < keys.length - 1 && Array.from(element).some(function (e) { return splitKeyValue(e[0])[0] === keys[i]; })) {
              var curLevel_1 = [];
              element.forEach(function (child, key) {
                  if (!exclude[key]) {
                      curLevel_1.push.apply(curLevel_1, nodeData(new Map(child)));
                  }
              });
              element = new Map();
              curLevel_1.forEach(function (item) {
                  if (element.has(item[0])) {
                      var dest = element.get(item[0]);
                      var src = item[1];
                      var newDest = new Map();
                      mergeData(dest, newDest, exclude);
                      mergeData(src, newDest, exclude);
                      element.set(item[0], newDest);
                  }
                  else {
                      element.set(item[0], new Map(item[1]));
                  }
              });
          }
          else if (i === 0 || i === keys.length - 1) {
              if (Array.from(element).some(function (e) { return splitKeyValue(e[0])[0] === keys[i]; })) {
                  result.push.apply(result, nodeData(element));
              }
          }
      };
      for (var i = 0; i < keys.length; i++) {
          _loop_1(i);
      }
      return result;
  };
  /** @hidden */
  var rootFields = function (definitions) {
      var fields = new Set();
      definitions.forEach(function (item) {
          if (item.name.length === 1 && !splitKeyValue(item.name[0])[1]) {
              fields.add(item.name[0]);
          }
      });
      return fields;
  };
  /** @hidden */
  var createTuples = function (axesSettings, definitions, dataTree, sortDescriptors, excludeFields) {
      var parentFields = rootFields(definitions);
      var flatMembers = [];
      var topTuple = getTopMembersTuple(parentFields, axesSettings);
      flatMembers.push(topTuple);
      var _loop_2 = function (i) {
          var currDef = definitions[i];
          if (currDef.name.length === 1 && !currDef.expand && parentFields.has(currDef.name[0])) {
              return "continue";
          }
          var keysToAdd = new Set(parentFields.keys());
          var currDefMembers = [];
          var keys = [];
          var tuples = [];
          var axe;
          currDef.name.forEach(function (element, index) {
              var _a;
              var _b = splitKeyValue(element), field = _b[0], value = _b[1];
              axe = axesSettings.find(function (a) { return a.key === field; });
              if (value) {
                  keysToAdd.delete(field);
                  keys.push(element);
                  var member = {
                      children: [],
                      caption: value,
                      hierarchy: field,
                      levelNum: 1,
                      levelName: field + " " + field,
                      name: element,
                      parentName: axe ? axe.caption : ""
                  };
                  currDefMembers.push(member);
              }
              else if (currDef.expand && currDef.name.length - 1 === index) {
                  keysToAdd.delete(element);
                  keys.push(element);
                  var children = childrenByKeys(dataTree, keys, excludeFields);
                  var descriptor = sortDescriptors.find(function (desc) { return desc.field === field; });
                  if (descriptor && descriptor.dir) {
                      children.sort(sortFunc(descriptor, axe));
                  }
                  for (var c = 0; c < children.length; c++) {
                      var leafValue = children[c][0];
                      var leafTuple = { members: [] };
                      tuples.push(leafTuple);
                      var caption = splitKeyValue(leafValue)[1];
                      axe = axesSettings.find(function (a) { return a.key === element; });
                      var member = {
                          caption: caption,
                          children: [],
                          levelName: element + " " + element,
                          levelNum: 1,
                          parentName: axe ? axe.caption : "",
                          hierarchy: element,
                          name: leafValue
                      };
                      (_a = leafTuple.members).push.apply(_a, currDefMembers);
                      leafTuple.members.push(member);
                  }
              }
              else if (currDef.expand) {
                  axe = axesSettings.find(function (a) { return a.key === element; });
                  var axisCaption = axe ? axe.caption : "";
                  keysToAdd.delete(element);
                  keys.push(element);
                  var member = {
                      children: [],
                      caption: axisCaption,
                      hierarchy: element,
                      levelName: axisCaption,
                      levelNum: 0,
                      name: axisCaption,
                      parentName: ""
                  };
                  currDefMembers.push(member);
              }
              keysToAdd.forEach(function (key) {
                  tuples.forEach(function (tuple) {
                      axe = axesSettings.find(function (a) { return a.key === key; });
                      var curCaption = axe ? axe.caption : "";
                      var member = {
                          children: [],
                          hasChildren: true,
                          caption: curCaption,
                          hierarchy: key,
                          levelName: curCaption,
                          levelNum: 0,
                          name: curCaption,
                          parentName: ""
                      };
                      tuple.members.push(member);
                  });
              });
              flatMembers.push.apply(flatMembers, tuples);
          });
      };
      for (var i = 0; i < definitions.length; i++) {
          _loop_2(i);
      }
      return flatMembers;
  };
  var measureToMember = function (measure) {
      return {
          caption: String(measure.name),
          children: [],
          hasChildren: false,
          hierarchy: "[Measures]",
          levelName: "[Measures].[MeasuresLevel]",
          levelNum: 0,
          name: "[Measures].[" + measure.name + "]",
          parentName: ""
      };
  };
  var addMeasure = function (tuple, measure) {
      var measureMember = measureToMember(measure);
      var tupleCopy = copy(tuple);
      tupleCopy.members.push(measureMember);
      return tupleCopy;
  };
  /** @hidden */
  var addMultipleMeasures = function (tuples, measures) {
      if (measures.length < 2) {
          return tuples;
      }
      var result = tuples.slice();
      for (var i = result.length - 1; i >= 0; i--) {
          var tuple = result[i];
          result[i] = addMeasure(result[i], measures[0]);
          for (var m = 1; m < measures.length; m++) {
              var tupleWithMeasure = addMeasure(tuple, measures[m]);
              result.splice(i + m, 0, tupleWithMeasure);
          }
      }
      return reverseColumnsByMeasures(result);
  };
  /** @hidden */
  var createLocalDataState = function (args) {
      var _a;
      var dataTree = args.dataTree, rowSettings = args.rowSettings, columnSettings = args.columnSettings, rowAxes = args.rowAxes, columnAxes = args.columnAxes, measures = args.measures, sort = args.sort, fields = args.fields;
      var exclude = (_a = {}, _a[fields.columnsData] = fields.columnsData, _a[fields.dataField] = fields.dataField, _a);
      var colTuples = columnAxes.length ?
          createTuples(columnSettings, columnAxes, dataTree.get(fields.columnsData), sort, exclude) :
          measures.map(function (m) { return ({ members: [measureToMember(m)] }); });
      var columnTuples = columnAxes.length > 0 ? addMultipleMeasures(colTuples, measures) : colTuples;
      var rowTuples = rowAxes.length ? createTuples(rowSettings, rowAxes, dataTree, sort, exclude) : [{ members: [] }];
      var resultData = readData(dataTree, rowTuples, columnTuples, fields, columnSettings, rowSettings, measures);
      return {
          columns: columnTuples,
          data: resultData,
          rows: rowTuples
      };
  };

  /** @hidden */
  var createFlatSchemaDimensions = function (dimensions, measures) {
      var result = Object.keys(dimensions).map(function (dim) { return ({
          caption: dim,
          defaultHierarchy: dim,
          description: '',
          name: dim,
          uniqueName: dim,
          hierarchyUniqueName: dim,
          measure: true,
          type: 1 // https://github.com/telerik/kendo-pivotgrid-common/blob/develop/src/models/responseDiscover.ts#L12-L14
      }); });
      if (measures.length) {
          result.push({
              caption: 'Measures',
              children: measures.map(function (m) { return ({
                  aggregator: '1',
                  caption: String(m.name),
                  defaultFormat: '',
                  description: '',
                  displayFolder: '',
                  groupName: String(m.name),
                  name: String(m.name),
                  uniqueName: String(m.name)
              }); }),
              type: 2,
              description: '',
              name: 'Measures',
              uniqueName: '[Measures]'
          });
      }
      return result;
  };

  // tslint:disable:object-literal-sort-keys

  var Navigation = /** @class */ (function () {
      function Navigation(options) {
          this.tabIndex = 0;
          this.root = null;
          this.eventHandlers = {};
          this.update = function () { };
          this.tabIndex = options.tabIndex;
      }
      Object.defineProperty(Navigation.prototype, "elements", {
          get: function () {
              return this.root ? Array.from(this.root.querySelectorAll(this.selectors.join(','))) : [];
          },
          enumerable: false,
          configurable: true
      });
      Object.defineProperty(Navigation.prototype, "first", {
          get: function () {
              return (this.root && this.root.querySelector(this.selectors.join(','))) || null;
          },
          enumerable: false,
          configurable: true
      });
      Object.defineProperty(Navigation.prototype, "last", {
          get: function () {
              var all = this.elements;
              return all[all.length - 1] || null;
          },
          enumerable: false,
          configurable: true
      });
      Object.defineProperty(Navigation.prototype, "current", {
          get: function () {
              return this.elements.find(function (el) { return el.matches(':focus'); });
          },
          enumerable: false,
          configurable: true
      });
      Navigation.prototype.start = function (root) {
          var _this = this;
          this.root = root;
          var _loop_1 = function (eventType) {
              if (this_1.mouseEvents[eventType]) {
                  this_1.eventHandlers[eventType] = (function (ev) {
                      var target = ev.target instanceof Element && ev.target.closest(_this.selectors.join(','));
                      if (target) {
                          _this.mouseEvents[eventType].call(undefined, target, _this, ev);
                      }
                  });
                  root.addEventListener(eventType, this_1.eventHandlers[eventType]);
              }
          };
          var this_1 = this;
          for (var eventType in this.mouseEvents) {
              _loop_1(eventType);
          }
          var _loop_2 = function (eventType) {
              if (this_2.keyboardEvents[eventType]) {
                  this_2.eventHandlers[eventType] = (function (ev) {
                      var target = ev.target instanceof Element && ev.target.closest(_this.selectors.join(','));
                      var key = ev.key === ' ' ? 'Space' : ev.key;
                      if (target && _this.keyboardEvents[eventType][key]) {
                          _this.keyboardEvents[eventType][key].call(undefined, target, _this, ev);
                      }
                  });
                  root.addEventListener(eventType, this_2.eventHandlers[eventType]);
              }
          };
          var this_2 = this;
          for (var eventType in this.keyboardEvents) {
              _loop_2(eventType);
          }
      };
      Navigation.prototype.stop = function () {
          if (this.root) {
              for (var eventType in this.eventHandlers) {
                  if (this.eventHandlers[eventType]) {
                      this.root.removeEventListener(eventType, this.eventHandlers[eventType]);
                  }
              }
          }
          this.root = null;
      };
      Navigation.prototype.focusElement = function (element, previous) {
          if (element) {
              if (previous) {
                  previous.removeAttribute('tabindex');
                  previous.classList.remove('k-focus');
              }
              element.setAttribute('tabindex', String(this.tabIndex));
              element.focus({ preventScroll: true });
          }
      };
      return Navigation;
  }());

  var scrollableValuesSel = '.k-pivotgrid .k-pivotgrid-values';
  var scrollableColumnHeaderSel = '.k-pivotgrid .k-pivotgrid-column-headers';
  var scrollableRowHeaderSel = '.k-pivotgrid .k-pivotgrid-row-headers';
  var emptyCellSel = '.k-pivotgrid > .k-pivotgrid-empty-cell';
  var tableSel = 'table.k-pivotgrid-table';
  var cellSel = '.k-pivotgrid-cell';
  var scrollables = [scrollableValuesSel, scrollableColumnHeaderSel, scrollableRowHeaderSel].join(',');
  var selectors$1 = [
      emptyCellSel,
      [scrollableColumnHeaderSel, tableSel, cellSel].join(' '),
      [scrollableRowHeaderSel, tableSel, cellSel].join(' '),
      [scrollableValuesSel, tableSel, cellSel].join(' ')
  ];
  var onEnter = function (target, nav, ev) {
      var icon = target.querySelector('.k-icon, .k-svg-icon');
      if (icon) {
          var index_1 = nav.elements.indexOf(target);
          nav.update = function () {
              nav.focusElement(nav.elements[index_1], null);
              nav.update = function () { };
          };
          icon.click();
          ev.preventDefault();
      }
  };
  var tryScrollLeft = function (target, scrollable, elToScroll) {
      if (target.offsetLeft < scrollable.scrollLeft) {
          elToScroll.scrollLeft = target.offsetLeft;
      }
  };
  var tryScrollRight = function (target, scrollable, elToScroll) {
      if (target.offsetLeft + target.offsetWidth > scrollable.scrollLeft + scrollable.offsetWidth &&
          target.offsetWidth < scrollable.offsetWidth) {
          elToScroll.scrollLeft = target.offsetLeft + target.offsetWidth - scrollable.offsetWidth;
      }
  };
  var tryScrollUp = function (target, scrollable, elToScroll) {
      if (scrollable.scrollTop && target.offsetTop < scrollable.scrollTop) {
          elToScroll.scrollTop = target.offsetTop;
      }
  };
  var tryScrollDown = function (target, scrollable, elToScroll) {
      if (target.offsetTop + target.offsetHeight > scrollable.scrollTop + scrollable.offsetHeight &&
          target.offsetHeight < scrollable.offsetHeight) {
          elToScroll.scrollTop = target.offsetTop + target.offsetHeight - scrollable.offsetHeight;
      }
  };
  var scrollTo = function (target, root, scrollFunc) {
      var elToScroll = root.querySelector(scrollableValuesSel);
      var scrollable = target && target.closest(scrollables);
      if (!elToScroll || !scrollable || !target) {
          return;
      }
      scrollFunc.forEach(function (scroll) { return scroll(target, scrollable, elToScroll); });
  };
  var tableMap = function (table) {
      var rows = Array.from(table.rows);
      var colsCount = Array.from((rows && rows[0] && rows[0].cells) || [])
          .map(function (c) { return c.colSpan; })
          .reduce(function (prev, cur) { return prev + cur; }, 0);
      var map = rows.map(function () { return new Array(colsCount); });
      rows.forEach(function (row, r) {
          var curColSpan = 0;
          Array.from(row.cells).forEach(function (c) {
              for (var colSp = 0; colSp < c.colSpan; colSp++) {
                  for (var rowSp = 0; rowSp < c.rowSpan; rowSp++) {
                      var ind = map[r + rowSp].findIndex(function (val, curInd) { return curInd >= curColSpan && !val; });
                      map[r + rowSp][ind] = c;
                  }
                  curColSpan++;
              }
          });
      });
      return map;
  };
  var navigationMap = function (root) {
      var columnHeader = tableMap(root.querySelector([scrollableColumnHeaderSel, tableSel].join(' ')));
      var rowHeader = tableMap(root.querySelector([scrollableRowHeaderSel, tableSel].join(' ')));
      var values = tableMap(root.querySelector([scrollableValuesSel, tableSel].join(' ')));
      var emptyCell = root.querySelector(emptyCellSel);
      var emptyCellRow = new Array(rowHeader[0].length).fill(emptyCell);
      var map = [];
      for (var i = 0; i < columnHeader.length; i++) {
          map.push(emptyCellRow.concat(columnHeader[i]));
      }
      for (var i = 0; i < rowHeader.length; i++) {
          map.push(rowHeader[i].concat(values[i]));
      }
      return map;
  };
  var getTargetPos = function (map, target) {
      for (var r = 0; r < map.length; r++) {
          for (var c = 0; c < map[r].length; c++) {
              if (map[r][c] === target) {
                  return [r, c];
              }
          }
      }
      return [-1, -1];
  };
  var ctrlKey = function (ev) { return ev.ctrlKey || ev.metaKey; };
  var cellAt = function (root, target, pos) {
      var map = navigationMap(root);
      var targetPos = getTargetPos(map, target);
      var nextPos = [targetPos[0] + pos[0], targetPos[1] + pos[1]];
      var next = map[nextPos[0]] && map[nextPos[0]][nextPos[1]];
      while (next && next === target) {
          nextPos = [nextPos[0] + pos[0], nextPos[1] + pos[1]];
          next = map[nextPos[0]] && map[nextPos[0]][nextPos[1]];
      }
      return next;
  };
  var keyboardEvents$1 = {
      keydown: {
          ArrowLeft: function (target, nav, ev) {
              ev.preventDefault();
              var next = cellAt(nav.root, target, [0, -1]);
              nav.focusElement(next, target);
              scrollTo(next, nav.root, [tryScrollRight, tryScrollLeft, tryScrollDown, tryScrollUp]);
          },
          ArrowRight: function (target, nav, ev) {
              ev.preventDefault();
              var next = cellAt(nav.root, target, [0, 1]);
              nav.focusElement(next, target);
              scrollTo(next, nav.root, [tryScrollLeft, tryScrollRight, tryScrollDown, tryScrollUp]);
          },
          ArrowUp: function (target, nav, ev) {
              ev.preventDefault();
              var next = cellAt(nav.root, target, [-1, 0]);
              nav.focusElement(next, target);
              scrollTo(next, nav.root, [tryScrollRight, tryScrollLeft, tryScrollDown, tryScrollUp]);
          },
          ArrowDown: function (target, nav, ev) {
              ev.preventDefault();
              var next = cellAt(nav.root, target, [1, 0]);
              nav.focusElement(next, target);
              scrollTo(next, nav.root, [tryScrollRight, tryScrollLeft, tryScrollUp, tryScrollDown]);
          },
          o: function (_target, nav, _ev) {
              if (!nav.root) {
                  return;
              }
              var next = nav.root.nextElementSibling;
              if (next && next instanceof HTMLElement && next.matches('div.k-pivotgrid-configurator-button')) {
                  next.click();
                  setTimeout(function () {
                      if (nav.root.parentNode) {
                          var confHeader = nav.root.parentNode.querySelector('.k-pivotgrid-configurator-content .k-form-field .k-fields-list-wrapper .k-treeview');
                          if (confHeader instanceof HTMLElement) {
                              confHeader.setAttribute('tabindex', String(nav.tabIndex));
                              confHeader.focus();
                          }
                      }
                  }, 0);
              }
          },
          Enter: onEnter,
          Space: onEnter,
          Home: function (target, nav, ev) {
              var map = navigationMap(nav.root);
              var ctrl = ctrlKey(ev);
              var row = ctrl ? map[0] : (map.find(function (ro) { return Boolean(ro.find(function (x) { return x === target; })); }) || []);
              var next = row[0];
              if (next) {
                  nav.focusElement(next, target);
                  scrollTo(next, nav.root, [tryScrollRight, tryScrollLeft, tryScrollDown, tryScrollUp]);
                  ev.preventDefault();
              }
          },
          End: function (target, nav, ev) {
              var map = navigationMap(nav.root);
              var ctrl = ctrlKey(ev);
              var row = ctrl ? map[map.length - 1] : (map.find(function (ro) { return Boolean(ro.find(function (x) { return x === target; })); }) || []);
              var next = row && row[row.length - 1] || null;
              if (next) {
                  nav.focusElement(next, target);
                  scrollTo(next, nav.root, [tryScrollLeft, tryScrollRight, tryScrollUp, tryScrollDown]);
                  ev.preventDefault();
              }
          }
      }
  };
  var mouseEvents$1 = {
      click: function (target, nav) {
          if (target && target instanceof HTMLElement) {
              var prev = nav.elements.find(function (c) { return c.hasAttribute('tabindex'); }) || null;
              nav.focusElement(target, prev);
          }
      }
  };
  /**
   * The PivotGrid keyboard navigation functionality.
   *
   * Usage:
   *
   * On Initialize
   * const navigation = new PivotGridNavigation({ tabindex: 0 });
   *
   * Turn on
   * navigation.start(rootDomElement);
   *
   * On After Update
   * navigation.update();
   *
   * On Destroy / Turn off
   * navigation.stop();
   */
  var PivotGridNavigation = /** @class */ (function (_super) {
      __extends(PivotGridNavigation, _super);
      function PivotGridNavigation() {
          var _this = _super !== null && _super.apply(this, arguments) || this;
          _this.selectors = selectors$1;
          _this.mouseEvents = mouseEvents$1;
          _this.keyboardEvents = keyboardEvents$1;
          return _this;
      }
      return PivotGridNavigation;
  }(Navigation));

  var selectors = [
      '.k-pivotgrid-configurator-content .k-form-field .k-fields-list-wrapper .k-treeview',
      '.k-pivotgrid-configurator-content .k-chip',
      '.k-pivotgrid-configurator-actions button'
  ];
  var onEscape = function (_target, nav, ev) {
      if (ev.target instanceof HTMLElement) {
          if (nav.root) {
              var pivot = nav.root.previousElementSibling;
              var confButton = nav.root.nextElementSibling;
              var pivotCell = Array.from(pivot instanceof HTMLElement ? pivot.querySelectorAll('[tabindex]') : []).find(function (c) { return c.tabIndex >= 0; });
              if (pivotCell instanceof HTMLElement) {
                  pivotCell.focus();
                  if (confButton instanceof HTMLElement) {
                      confButton.click();
                  }
              }
          }
      }
  };
  var navigate = function (target, nav, ev, dir) {
      ev.preventDefault();
      var all = nav.elements;
      var index = all.indexOf(target) + dir;
      if (index < 0) {
          index = all.length - 1;
      }
      nav.focusElement(all[index % all.length], target);
  };
  var onDelete = function (target, nav, ev) {
      if (ev.target instanceof HTMLElement) {
          var deleteButton = ev.target.querySelector('.k-icon.k-i-x-circle, .k-svg-icon.k-svg-i-x-circle');
          if (deleteButton instanceof HTMLElement) {
              ev.preventDefault();
              navigate(target, nav, ev, -1);
          }
      }
  };
  var keyboardEvents = {
      keydown: {
          Tab: function (target, nav, ev) {
              navigate(target, nav, ev, ev.shiftKey ? -1 : 1);
          },
          Escape: onEscape,
          Delete: onDelete,
          Backspace: onDelete
      }
  };
  var mouseEvents = {
      click: function (target, nav) {
          if (target && target instanceof HTMLElement) {
              var prev = nav.elements.find(function (c) { return c.hasAttribute('tabindex'); }) || null;
              nav.focusElement(target, prev);
          }
      }
  };
  /**
   * The PivotGrid Configurator keyboard navigation functionality.
   *
   * Usage:
   *
   * On Initialize
   * const navigation = new ConfiguratorNavigation({ tabindex: 0 });
   *
   * Turn on
   * navigation.start(rootDomElement);
   *
   * On After Update
   * navigation.update();
   *
   * On Destroy / Turn off
   * navigation.stop();
   */
  var ConfiguratorNavigation = /** @class */ (function (_super) {
      __extends(ConfiguratorNavigation, _super);
      function ConfiguratorNavigation() {
          var _this = _super !== null && _super.apply(this, arguments) || this;
          _this.selectors = selectors;
          _this.mouseEvents = mouseEvents;
          _this.keyboardEvents = keyboardEvents;
          return _this;
      }
      return ConfiguratorNavigation;
  }(Navigation));

  exports.A = createAxisDescriptors;
  exports.B = configuratorReducer;
  exports.C = compareAxes;
  exports.D = cloneDataTree;
  exports.E = buildKPIMeasures;
  exports.F = addMultipleMeasures;
  exports.G = addKPI;
  exports.I = ConfiguratorNavigation;
  exports.P = PivotGridNavigation;
  exports.__meta__ = __meta__;
  exports.a = createLocalDataState;
  exports.b = countAggregate;
  exports.c = createDataTree;
  exports.d = minAggregate;
  exports.e = averageAggregate;
  exports.f = fetchDiscover;
  exports.g = fetchData;
  exports.h = createDataState;
  exports.i = headersReducer;
  exports.j = toTree;
  exports.k = toColumns;
  exports.l = toRows;
  exports.m = maxAggregate;
  exports.n = setSort;
  exports.o = setFilter;
  exports.p = readData;
  exports.q = parseResponse;
  exports.r = rootFields;
  exports.s = sumAggregate;
  exports.t = toData;
  exports.u = mergeTrees;
  exports.v = discoverCommands;
  exports.w = createTuples;
  exports.x = createRequestBody;
  exports.y = createFlatSchemaDimensions;
  exports.z = createDiscoverBody;

}));
